//GETTERS
export const GET_MASSIVE_DEPENDENTS_EXCLUSION_URL =
  'massive-exclusion/GET_MASSIVE_DEPENDENTS_EXCLUSION_URL';
export const GET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL =
  'massive-exclusion/GET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL';
export const GET_MASSIVE_DEPENDENTS_EXCLUSION_FILE =
  'massive-exclusion/GET_MASSIVE_DEPENDENTS_EXCLUSION_FILE';
export const GET_TICKET_GROUP_OPTIONAL_FILES =
  'massive-exclusion/GET_TICKET_GROUP_OPTIONAL_FILES';

//SETTERS
export const SET_MASSIVE_DEPENDENTS_EXCLUSION_URL =
  'massive-exclusion/SET_MASSIVE_DEPENDENTS_EXCLUSION_URL';
export const SET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL =
  'massive-exclusion/SET_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL';
export const SET_MASSIVE_DEPENDENTS_EXCLUSION_FILE =
  'massive-exclusion/SET_MASSIVE_DEPENDENTS_EXCLUSION_FILE';
export const SET_TICKET_GROUP_OPTIONAL_FILES =
  'massive-exclusion/SET_TICKET_GROUP_OPTIONAL_FILES';

//ACTIONS
export const FETCH_MASSIVE_DEPENDENTS_EXCLUSION_URL =
  'massive-exclusion/FETCH_MASSIVE_DEPENDENTS_EXCLUSION_URL';
export const FETCH_MASSIVE_DEPENDENTS_EXCLUSION_OF_TICKET =
  'massive-exclusion/FETCH_MASSIVE_DEPENDENTS_EXCLUSION_OF_TICKET';
export const POST_MASSIVE_CANCEL_DEPENDENTS_EXCLUSION =
  'massive-exclusion/POST_MASSIVE_CANCEL_DEPENDENTS_EXCLUSION';
export const POST_MASSIVE_FINISH_DEPENDENTS_EXCLUSION =
  'massive-exclusion/POST_MASSIVE_FINISH_DEPENDENTS_EXCLUSION';
export const POST_MASSIVE_DEPENDENTS_EXCLUSION =
  'massive-exclusion/POST_MASSIVE_DEPENDENTS_EXCLUSION';
export const FETCH_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL =
  'massive-exclusion/FETCH_MASSIVE_DEPENDENTS_EXCLUSION_DETAIL';
export const FETCH_MASSIVE_DEPENDENTS_EXCLUSION_FILE =
  'massive-exclusion/FETCH_MASSIVE_DEPENDENTS_EXCLUSION_FILE';
export const FETCH_TICKET_GROUP_OPTIONAL_FILES =
  'massive-exclusion/FETCH_TICKET_GROUP_OPTIONAL_FILES';
export const MASSIVE_DEPENDANTS_EXCLUSION_PRE_SUCCESS =
  'massive-exclusion/MASSIVE_DEPENDANTS_EXCLUSION_PRE_SUCCESS';
export const MASSIVE_DEPENDANTS_EXCLUSION_SUCCESS =
  'massive-exclusion/MASSIVE_DEPENDANTS_EXCLUSION_SUCCESS';
export const MASSIVE_DEPENDANTS_EXCLUSION_PRE_CANCEL =
  'massive-exclusion/MASSIVE_DEPENDANTS_EXCLUSION_PRE_CANCEL';
export const MASSIVE_DEPENDANTS_EXCLUSION_CANCEL =
  'massive-exclusion/MASSIVE_DEPENDANTS_EXCLUSION_CANCEL';
